import { withProps, mapProps } from 'recompose'
import { Field } from 'formik'
import NumberFormat from 'react-number-format'
import TextField from '@material-ui/core/TextField'

const PhoneField = mapProps(({ form, field, options, ...props }) => ({
  ...props,
  type: 'tel',
  format: '(##) #####-####',
  placeholder: '(DD) #####-####',
  customInput: TextField,
  value: field.value && field.value.replace('+55', ''),
  onBlur: () => form.setFieldTouched(field.name, true),
  onValueChange: values =>
    form.setFieldValue(field.name, `+55${values.value}` || '')
}))(NumberFormat)

export default withProps({ component: PhoneField })(Field)
